import { initializeSyncfusion } from "@/integrations/syncfusion";
import { initializeBugsnag } from "@/integrations/bugsnag";
import { initializeApplicationInsights } from "@/integrations/applicationInsights";

export default function init() {
  initializeSyncfusion();
  initializeBugsnag();
  initializeApplicationInsights();
}
